import axios from 'axios'
import { getBFFUrl, getToken } from './requests'

export const getCards = async () => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/cards`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return res.data.data.cards
}

export const deleteCard = async transactionID => {
  const token = await getToken()

  await axios.delete(`${getBFFUrl()}/cards?transactionID=${transactionID}`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return true
}

export const addCard = async transactionID => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/addCard?cardToken=${transactionID}`, {
    params: {
      operator: 'BALSAS',
    },
    headers: {
      'x-access-token': token,
      operator: 'DemoBalsas',
    },
  })

  return res.data
}
